module.exports = __webpack_public_path__ + "static/media/us.aefba3fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/us.svg
// module id = 278
// module chunks = 0